import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@ff-os/shared-react/components/alert/Alert';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { NumberInputField } from '@ff-os/shared-react/components/input/number-input/NumberInputField';
import { Heading } from '@ff-os/shared-react/components/panel/Heading';
import { Panel } from '@ff-os/shared-react/components/panel/Panel';
import styles from './OverviewWindowBody.module.scss';

export const OverviewWindowBody = ({ quantity, setQuantity, hasPushError }: Props) => {
    const { t } = useTranslation();
    return (
        <Grid direction='column' gap='s' className={styles.grid}>
            {hasPushError && (
                <Cell fit>
                    <Alert icon='alert-triangle-exclamation' type='error'>
                        {t('order_button.error_message')}
                    </Alert>
                </Cell>
            )}

            <Cell fit>
                <Panel>
                    <Heading>{t('commons.amount')}</Heading>
                    <NumberInputField
                        label={t('commons.amount')}
                        value={quantity} commit={setQuantity} />
                </Panel>
            </Cell>
        </Grid>
    );
};

type Props = {
    quantity: number;
    setQuantity: (amount: number) => void;
    hasPushError: boolean;
};